(ns ncr.sysinfo
  (:require
   [clojure.core.match :refer [match]]
   [cljs.core.async :as async :refer-macros [go]]
   [tick.core :as t]
   [uix.core.alpha :as uix]
   [ncr.etc.util :as u]
   [ncr.etc.pf :as pf]
   [ncr.etc.pubsub :as ps]
   [ncr.backend-http :as bh]))

(defonce info
  (async/promise-chan))

(go
  (async/>! info
    {:client
     (match (<! (bh/get "/buildinfo.json" {:as :stream}))
       {:success true :body body}
       body
       {:success false :status 404}
       nil
       _
       [:error :noinfo]
       _
       nil)

     :server
     (match (<! (bh/get "/api/serverinfo.json" {:as :stream}))
       {:success true :body body}
       body
       {:success false :status 404}
       nil
       _
       [:error :noinfo])}))

(defn- c-about-entry [name value]
  [:<>
   [pf/c-text-list-item {:component :dt} name]
   [pf/c-text-list-item {:component :dd} value]])

(defn- c-timestamp [date]
  (let
    [ts
     (or
       (try
         (u/parse-number date)
         (catch js/Error _
           nil)) 0)]

    [:span
     (t/format "MMM d, HH:mm 'CET'"
       (-> ts (t/instant) (t/zoned-date-time)))]))

(defn c-about []
  (let
    [is-open
     @(ps/sub-reducer-map! false
        {:about/open
         (constantly true)
         :about/close
         (constantly false)})

     loaded
     (uix/state {})]

    (uix/with-effect []
      (go
        (reset! loaded
          (<! info))))

    (when is-open
      [pf/c-about-modal
       {:is-open true
        :trademark "SUPREMATIC Technology Arts GmbH (c) 2024"
        :product-name "NECKAR"

        :on-close
        #(ps/pub! [:about/close])}

       (let [default {:commit "deadbeef" :version "0.0.2" :date "0" :build "0"}]
         [pf/c-text-content
          [pf/c-text-list {:component :dl}
           (u/error-m
             [client (get @loaded :client)
              {:keys [commit version date build]} (or client default)]
             [:<>
              [c-about-entry "Client Version" version]
              [c-about-entry "Client Build" (u/format "%s-%s" commit build)]
              [c-about-entry "Build Time" [c-timestamp date]]])

           [:br]

           (u/error-m
             [{:keys [buildinfo instance]} (get @loaded :server)
              {:keys [commit version date build]} (or buildinfo default)]
             [:<>
              [c-about-entry "Server Version" version]
              [c-about-entry "Server Build" (u/format "%s-%s" commit build)]
              [c-about-entry "Build Time" [c-timestamp date]]
              [c-about-entry "Instance" (or instance "unknown")]])]])])))
